import { BufferAttribute, BufferGeometry, RawShaderMaterial, LineSegments } from "three";

import face_vert from "./glsl/sim/face.vert";
import line_vert from "./glsl/sim/line.vert";

import advection_frag from "./glsl/sim/advection.frag";
import ShaderPass from "./ShaderPass";

export default class Advection extends ShaderPass{
    constructor(simProps){
        super({
            material: {
                depthWrite: false,
                depthTest: false,
                vertexShader: face_vert,
                fragmentShader: advection_frag,
                uniforms: {
                    boundarySpace: {
                        value: simProps.cellScale
                    },
                    px: {
                        value: simProps.cellScale
                    },
                    fboSize: {
                        value: simProps.fboSize
                    },
                    velocity: {
                        value: simProps.src.texture
                    },
                    dt: {
                        value: simProps.dt
                    },
                    dissipation: {
                        value: .95
                    }
                },
            },
            output: simProps.dst
        });

        this.init();
    }

    init(){
        super.init();
        this.createBoundary();
    }

    createBoundary(){
        const boundaryG = new BufferGeometry();
        const vertices_boundary = new Float32Array([
            // left
            -1, -1, 0,
            -1, 1, 0,

            // top
            -1, 1, 0,
            1, 1, 0,

            // right
            1, 1, 0,
            1, -1, 0,

            // bottom
            1, -1, 0,
            -1, -1, 0
        ]);
        boundaryG.setAttribute( 'position', new BufferAttribute( vertices_boundary, 3 ) );

        const boundaryM = new RawShaderMaterial({
            vertexShader: line_vert,
            fragmentShader: advection_frag,
            uniforms: this.uniforms
        });

        this.line = new LineSegments(boundaryG, boundaryM);
        this.scene.add(this.line);
    }

    update({ dt, isBounce, BFECC }){

        this.uniforms.dt.value = dt;
        this.line.visible = isBounce;

        super.update();
    }

    destroy() {
        super.destroy();

        if (this.line) {
            if (this.line.geometry) {
                this.line.geometry.dispose();
            }
            if (this.line.material) {
                this.line.material.dispose();
            }
            this.scene.remove(this.line);
            this.line = null;
        }

        for (let key in this.uniforms) {
            this.uniforms[key].value = null;
        }
        this.uniforms = null;

        this.output = null;
    }
}
